import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Paper } from "@mui/material";
import { useQuery } from "react-query";
import { ORGANISATIONS_AUTOCOMPLETE_LIMIT } from "@config/config.client";
import { useFormContext } from "react-hook-form";

interface Props {}

export const AsyncAutocompleteSearch: FC<Props> = ({}) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly string[]>([]);

  // Form state.
  const {
    register,
    control,
    getValues,
    watch,
    setValue,
    // formState: { errors },
  } = useFormContext();

  const value = getValues("search");

  // Fetch search. (based on search params)
  const fetchSearches = async () => {
    const url = `/api/search/search?name=${value}`;
    return fetch(url).then((res) => res.json());
  };

  const { isLoading } = useQuery(["search", value], fetchSearches, {
    onSuccess: (data) => {
      const sortedOptions = data.search.sort((a, b) =>
        a < b ? -1 : a > b ? 1 : 0
      );
      const sortedOptionsWithAddNewOrganisation = [...sortedOptions, value];
      const newOptions =
        data.length === ORGANISATIONS_AUTOCOMPLETE_LIMIT
          ? sortedOptions
          : sortedOptionsWithAddNewOrganisation;
      setOptions(newOptions);
    },
  });

  return (
    <Autocomplete
      multiple={false}
      classes={{
        root: "",
        inputRoot: "bg-transparent rounded-l-md rounded-r-none hover:bg-white",
        focused: "bg-white rounded-l-md",
        input: "text-base font-medium bg-transparent",
        inputFocused: "focus:ring-0",
        clearIndicator: "mr-2",
        popper: "relative w-full m-0 p-0 shadow border-t",
        paper: "rounded-none shadow-none m-0 p-0",
        listbox: "rounded-none m-0 p-0",
        option: "text-sm m-0 p-0",
      }}
      sx={{
        "& .MuiFilledInput-root": {
          backgroundColor: "white",
          paddingLeft: "12px",
          // paddingTop: "22px",
          paddingBottom: "4px",
        },
        "& .MuiFilledInput-root:hover": {
          backgroundColor: "white",
        },
        "& .MuiFilledInput-root.Mui-focused": {
          backgroundColor: "white",
        },
        // labels
        // - default state
        "& .MuiFormLabel-root": {
          paddingLeft: "5px",
          color: "#aaa",
          // fontSize: "0.9rem",
        },
        // - filled state
        "& .MuiInputLabel-filled.Mui-focused": {
          color: "#aaa",
        },
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      inputValue={value || ""}
      onChange={(_, value) => {
        // triggered by selection
        setValue("search", value);
      }}
      onInputChange={(_, value) => {
        // triggered by clear button
        setValue("search", value);
      }}
      options={options}
      freeSolo={true}
      getOptionLabel={(option) => option || ""}
      isOptionEqualToValue={(option, value) => {
        return option === value;
      }}
      loading={isLoading}
      filterSelectedOptions
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            variant="filled"
            label="Search by title, skill, or company..."
            onChange={(e) => {
              // triggered by typing
              setValue("search", e.target.value);
            }}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
            autoFocus
          />
        );
      }}
      // Enable this to remove the portal - ie. to render the dropdown relatively positioned in the DOM
      // PopperComponent={(props) => {
      //   const { disablePortal, anchorEl, ...rest } = props;
      //   return <Paper {...rest} />;
      // }}
    />
  );
};
